// Custom components
import {
  FieldValues,
  FieldErrors,
  ControllerRenderProps,
} from "react-hook-form";
import Select from "react-select";

function SelectField(props: {
  field: ControllerRenderProps<FieldValues, any>;
  id: string;
  label: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  isMulti?: boolean;
  disabled?: boolean;
  onInputChange?: (inputValue: string) => void;
  options: any[];
  optionValue?: string | ((option: any) => string);
  optionLabel?: string | ((option: any) => string);
  errors: FieldErrors<FieldValues>;
  rules: {
    required?: boolean | string;
    minLength?: number | { value: number; message: string };
    maxLength?: number | { value: number; message: string };
    pattern?: RegExp | { value: RegExp; message: string };
    validate?: (value: string) => boolean | string;
  };
}) {
  const {
    label,
    id,
    extra,
    placeholder,
    variant,
    state,
    isMulti,
    disabled,
    options,
    field,
    errors,
    rules,
    onInputChange,
    optionValue,
    optionLabel,
  } = props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-navy-700 dark:text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        } ${isMulti && "basic-multi-select"}`}
      >
        {" "}
        {label}
        {rules.required && (
          <span className="text-red-500 dark:text-red-400">*</span>
        )}
      </label>
      <Select
        value={field.value}
        onChange={field.onChange}
        onInputChange={onInputChange}
        ref={field.ref}
        options={options}
        isMulti={isMulti}
        placeholder={placeholder}
        getOptionValue={
          optionValue
            ? typeof optionValue === "string"
              ? (option) => option[optionValue]
              : optionValue
            : () => {}
        }
        getOptionLabel={
          optionLabel
            ? typeof optionLabel === "string"
              ? (option) => {
                  return option[optionLabel];
                }
              : optionLabel
            : () => {}
        }
        classNames={{
          placeholder: () =>
            `!text-gray-400 dark:text-white/50 ${
              state === "error" ||
              (errors[id] &&
                "!border-red-500 !text-red-500 placeholder:!text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400")
            }`,
          control: () =>
            `mt-2 flex !h-auto w-full items-center justify-center !rounded-xl border !bg-white/0 !pb-1 !pl-3 !pt-1 text-sm outline-none transition-all duration-300 ${
              disabled === true
                ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
                : state === "error" || errors[id]
                ? "!border-red-500 !text-red-500 placeholder:!text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
                : state === "success"
                ? "!border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
                : "!border-gray-200 dark:!border-white/10 dark:text-white"
            }`,
          option: () =>
            `!text-gray-700 dark:!text-white/50 dark:!bg-navy-700 dark:hover:!bg-navy-600 dark:focus:!bg-navy-600 dark:active:!bg-navy-600`,
          multiValueLabel: () => `!text-white dark:!text-white/50`,
          multiValueRemove: () =>
            `!text-white/75 hover:!bg-brand-600 !rounded-tr-lg !rounded-b-r-lg`,
          multiValue: () =>
            `!bg-brand-500 !rounded-lg !text-white dark:!text-white/50 dark:!bg-white/10`,
        }}
      />
      {errors[id] && (
        <span className="ml-2 mt-1 text-sm text-red-500 dark:text-red-400">
          {errors[id].message.toString()}
        </span>
      )}
    </div>
  );
}

export default SelectField;
